// extracted by mini-css-extract-plugin
module.exports = {"category":"enllac_category__LdBAM","boto":"enllac_boto__pTUyv"};